import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Colleague } from './colleague-photo';
import { ApiRequestService } from '../shared/api-request-service';
import { HttpError } from '../shared/httperror';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../toastmessage/toastmessage.service';
import { GetColleagueResponse } from './getcolleagueresponse';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { GoogleTagManagerService } from '../google-tag-manager/google-tag-manager.service';
import { MetaService } from '../meta/meta.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'pw-introduction',
    templateUrl: './introduction.component.html',
    styleUrls: ['./introduction.component.scss']
})
export class IntroductionComponent implements OnInit {
    colleagues: Colleague[] = [];

    colleagueUrl = '/websiteconfigurator/get-colleagues';

    configuratorBaseUrl = '';

    @Input() hasGoogleMap = false;

    isRowView = true;

    @Input() googleMapIframeSrc = '';

    patientAdmissonFormUrl: string | undefined;

    email: string | undefined;

    address: string | undefined;

    phoneNumber: string | undefined;

    logoUrl: string | undefined;

    landlinePhoneNumber: string | undefined;

    cellphoneNumber: string | undefined;

    nameOfLink = 'IDŐPONTFOGLALÁS LINK MEGTEKINTÉSE'

    @Input() bookAppointmentsUrl = 'https://medicall.cc/idopontfoglalas/regenero/index';


    constructor(private _http: HttpClient,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService,
        private _googleTagManagerService: GoogleTagManagerService,
        private _metaService: MetaService

    ) {

        this.configuratorBaseUrl = _configuratorBaseUrl;

        this._metaService.settingUpOgUrl();
    }

    ngOnInit(): void {
        this._apiRequestService
            .sendRequest<{}, GetColleagueResponse>(this.configuratorBaseUrl, true, {}, true, this.colleagueUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();

                    });
                })
            )
            .subscribe((response: GetColleagueResponse) => {
                this.colleagues = response.colleagueList as Colleague[];
                if (sessionStorage.getItem('email')) {
                    this.email = JSON.parse(sessionStorage.getItem('email') as string);
                }
                if (sessionStorage.getItem('landline_phone_number')) {
                    this.landlinePhoneNumber = JSON.parse(sessionStorage.getItem('landline_phone_number') as string);
                }
                if (sessionStorage.getItem('cellphone_number')) {
                    this.cellphoneNumber = JSON.parse(sessionStorage.getItem('cellphone_number') as string);
                }
                if (sessionStorage.getItem('address')) {
                    this.address = JSON.parse(sessionStorage.getItem('address') as string);
                }
                if (sessionStorage.getItem('patient_admisson_form_url')) {
                    this.patientAdmissonFormUrl = JSON.parse(sessionStorage.getItem('patient_admisson_form_url') as string);
                }


            });


        // this._http.get<Colleague[]>(this.colleagueUrl).subscribe({
        //     next: (colleagues) => {
        //         colleagues.forEach((colleague) => {
        //             colleague.imageUrl = this.downloadFileUrl + colleague.imageUrl;
        //         });
        //         this.colleagues = colleagues;


        //     }
        // });
    }

    settingUpLinkToGoogleAnalytics() {
        this._googleTagManagerService.pushLinkIntoDataLayer(this.nameOfLink, this.bookAppointmentsUrl);
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
}
